import { getDOMAspect, isLandscape, isRTL } from './Responsive.helper';
import { BREAKPOINTS, ORDERED_BREAKPOINTS } from './Responsive.constants';

function isBrowserGreaterThan(
  currentBreakpoint: Breakpoint,
  breakpoint: Breakpoint = BREAKPOINTS.XXS,
) {
  const currentBpIndex = ORDERED_BREAKPOINTS.indexOf(currentBreakpoint);
  const stepIndex = ORDERED_BREAKPOINTS.indexOf(breakpoint);
  return currentBpIndex > stepIndex;
}

function isDesktop(breakpoint: Breakpoint) {
  return breakpoint === BREAKPOINTS.L || breakpoint === BREAKPOINTS.XL;
}

function isTablet(breakpoint: Breakpoint) {
  return breakpoint === BREAKPOINTS.S || breakpoint === BREAKPOINTS.M || isDesktop(breakpoint);
}

function isMobile(breakpoint: Breakpoint) {
  return breakpoint === BREAKPOINTS.XXS || breakpoint === BREAKPOINTS.XS || isTablet(breakpoint);
}

function getCurrentResponsive({
  currentBreakpoint,
  isAppMounted,
}: Partial<ResponsiveProps>): ResponsiveProps {
  return {
    isAppMounted,
    currentBreakpoint,
    domAspect: getDOMAspect(),
    isLandscape: isLandscape(),
    isRTL: isRTL(),
    isMobile: isMobile(currentBreakpoint),
    isTablet: isTablet(currentBreakpoint),
    isDesktop: isDesktop(currentBreakpoint),
    isBrowserGreaterThan: {
      [BREAKPOINTS.XXS]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.XXS),
      [BREAKPOINTS.XS]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.XS),
      [BREAKPOINTS.S]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.S),
      [BREAKPOINTS.M]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.M),
      [BREAKPOINTS.L]: isBrowserGreaterThan(currentBreakpoint, BREAKPOINTS.L),
    },
  };
}

export default getCurrentResponsive;
